import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { Produto } from '../domain/produto.model';

export class ProdutoSerializer extends DomainSerializer<Produto> {}
